export const INVOICE_LIST = "INVOICE_LIST";
